export default {
  OriginalInvoice: 1, //(Hóa đơn gốc)
  DeletedInvoice: 2, //(Xóa bỏ)
  ReplaceInvoice: 3, //(Thay thế)
  AdjustInvoice: 4, //(Điều chỉnh)
};
